'use strict';

angular.module('uniromaLandingApp')
    .factory('ScheduledJobStats', ['$resource','DateUtils',function ($resource, DateUtils) {
        return $resource('api/scheduledJobStats/stats', {}, {
            'query': { method: 'GET', isArray: true}
            
        });
    }]);
